import React from "react";

const Output = ({ state }) => {
  const styles = {
    container: {
      width: 280,
      height: 40,
      display: 'flex',
      alignItems: "center"
    },
    text: {
      backgroundColor: '#013469',
      margin: 10,
      fontSize: 15,
      width: "70%",
      border: "2px solid #E43522",
      color: "#fff",
      borderRadius: 10,
      textAlign: "center",
      padding: "8px",
      marginLeft: "auto",
      marginRight: "auto"
    }
  };
    
  return (
    <div>
      <div style={styles.container}>
        <div style={styles.text}>{state}</div>
      </div>
    </div>
  );
};

export default Output;